import { Directive, computed, input } from '@angular/core';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { injectCustomClassSettable } from '@spartan-ng/brain/core';
import { BrnSheetOverlay } from '@spartan-ng/brain/sheet';
import { hlm } from '@spartan-ng/helm/utils';
import type { ClassValue } from 'clsx';
import { pipe, tap } from 'rxjs';

@Directive({
    hostDirectives: [BrnSheetOverlay],
    selector: '[hlmSheetOverlay],hlm-sheet-overlay',
})
export class HlmSheetOverlay {
    private readonly _classSettable = injectCustomClassSettable({ host: true, optional: true });

    public readonly userClass = input<ClassValue>('', { alias: 'class' });

    protected readonly _computedClass = computed(() =>
        hlm(
            'data-open:animate-in data-closed:animate-out data-closed:fade-out-0 data-open:fade-in-0 isolate bg-black/10 duration-100 supports-backdrop-filter:backdrop-blur-xs',
            this.userClass()
        )
    );

    // Pushes the merged class through the brain classSettable host-directive API - not template-bindable,
    // so it is driven reactively via rxMethod (cleanup is tied to this directive's injection context).
    private readonly _applyClass = rxMethod<string>(
        pipe(tap((newClass) => this._classSettable?.setClassToCustomElement(newClass)))
    );

    constructor() {
        this._applyClass(this._computedClass);
    }
}
